import React from "react";

function HomeIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="34"
            height="34"
            fill="none"
            viewBox="0 0 34 34"
        >
            <mask
                id="mask0_0_5188"
                style={{ maskType: "alpha" }}
                width="34"
                height="34"
                x="0"
                y="0"
                maskUnits="userSpaceOnUse"
            >
                <path
                    fill="#D9D9D9"
                    d="M0.906 0.871H33.164V33.129000000000005H0.906z"
                ></path>
            </mask>
            <g fill="#000" mask="url(#mask0_0_5188)">
                <path d="M16.81 5.709c-4.133 0-7.496 3.363-7.496 7.496 0 2.48 1.721 5.263 3.482 7.46-2.164.667-3.482 1.842-3.482 3.156 0 2.086 3.293 3.72 7.496 3.72s7.496-1.634 7.496-3.72c0-1.314-1.318-2.49-3.481-3.155 1.76-2.198 3.48-4.98 3.48-7.461 0-4.134-3.362-7.496-7.495-7.496zm6.604 18.112c0 1.365-2.654 2.827-6.604 2.827s-6.604-1.462-6.604-2.827c0-.955 1.251-1.885 3.21-2.407a35.094 35.094 0 003.098 3.202.443.443 0 00.591 0 35.079 35.079 0 003.099-3.202c1.959.522 3.21 1.452 3.21 2.407zm-6.604-.145c-1.32-1.239-6.604-6.45-6.604-10.471A6.611 6.611 0 0116.81 6.6a6.611 6.611 0 016.604 6.604c0 4.017-5.283 9.23-6.604 10.471z"></path>
                <path d="M21.756 11.537l-4.753-2.293a.528.528 0 00-.388 0l-4.753 2.293a.446.446 0 00.387.803l.967-.466v4.843c0 .246.2.446.446.446h6.294c.246 0 .445-.2.445-.446v-4.843l.967.466a.446.446 0 10.388-.803zm-4.36 4.733H16.22v-2.292h1.174v2.292zm2.114 0h-1.222v-2.738c0-.247-.2-.446-.446-.446h-2.066c-.247 0-.446.2-.446.446v2.738h-1.222v-4.827l2.7-1.302 2.702 1.303v4.826z"></path>
            </g>
        </svg>
    );
}

export default HomeIcon;
